export default __webpack_public_path__ + "static/media/Ronald Frey.cc91a336.jpg";